function iOS() {
	return (
	  [
		 "iPad Simulator",
		 "iPhone Simulator",
		 "iPod Simulator",
		 "iPad",
		 "iPhone",
		 "iPod",
	  ].includes(navigator.platform) ||
	  (navigator.userAgent.includes("Mac") && "ontouchend" in document)
	);
 }

let topRel = 0;

window.addEventListener("scroll", () => {
	topRel = window.scrollY / document.documentElement.scrollHeight;
});

window.addEventListener("orientationchange", () => {
	let topAbs = topRel * document.documentElement.scrollHeight;

	if (iOS()) {
		window.scrollTo({
			top: topAbs,
			left: 0,
			behavior: "auto",
		});
	}
});